import React from "react";
import { motion } from "framer-motion";
import { Users, CircleCheck, CircleAlert, RotateCw, Smartphone } from "lucide-react";
import { contentFor, deepLink } from "./inviteContent";
import { InviteDetails } from "./InviteDetails";

const ICONS = { pending: Users, accepted: CircleCheck };

export const InviteCard = ({ token, status, data, onRetry }) => {
  const c = contentFor(status, data);
  const Icon = ICONS[status] || CircleAlert;
  const ok = c.tone === "ok";
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      data-testid={`invite-status-${status in { pending: 1, accepted: 1, declined: 1, expired: 1, error: 1 } ? status : "invalid"}`}
    >
      <div
        className={`flex h-14 w-14 items-center justify-center rounded-2xl ${
          ok ? "bg-[#E4EDE6] text-[#2F5E43]" : "bg-[#F1F2F0] text-[#6B7A70]"
        }`}
      >
        <Icon className="h-7 w-7" />
      </div>
      <h1
        className="font-heading mt-6 text-3xl font-semibold leading-tight tracking-tight text-[#111E16] sm:text-4xl"
        data-testid="invite-title"
      >
        {c.title}
      </h1>
      <p className="mt-4 text-base leading-relaxed text-[#4A5F52]" data-testid="invite-body">
        {c.body}
      </p>
      {status === "pending" && data && <InviteDetails data={data} />}
      {c.cta && (
        <>
          <a
            href={deepLink(token)}
            className="mt-8 flex w-full items-center justify-center gap-2 rounded-full bg-[#2F5E43] px-6 py-4 font-semibold text-white shadow-lg shadow-[#2F5E43]/20 transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-[#244A34]"
            data-testid="invite-open-app-btn"
          >
            <Smartphone className="h-5 w-5" /> {c.cta}
          </a>
          <p className="mt-3 text-center text-xs text-[#6B7A70]" data-testid="invite-open-app-hint">
            Open this link on the phone where SisterSafe is installed.
          </p>
        </>
      )}
      {c.retry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-8 inline-flex items-center gap-2 rounded-full border border-[#2F5E43]/20 px-6 py-3 font-semibold text-[#2F5E43] transition-colors hover:bg-[#E4EDE6]"
          data-testid="invite-retry-btn"
        >
          <RotateCw className="h-4 w-4" /> Try again
        </button>
      )}
    </motion.div>
  );
};
